<div class="bid-items-site-quantities flex flex-col">
  <div class="bid-items-site-quantities-content flex-1 flex flex-col min-h-0">
    <ng-container *ngIf="sitesList?.length; else emptyState">
      <div class="site-quantity-row flex items-center justify-between py-[12px]" *ngFor="let site of sitesList">
        <ng-container *ngIf="canEdit; else viewQuantity">
          <app-number-input
            [parentFormGroup]="sitesForm"
            [controlName]="site?.id"
            [label]="(site?.name || 'Site') + ' Quantity'"
            class="quantity-field flex-1 min-w-0"
          />
          <div class="site-save-icon flex-[0_0_20%] flex justify-end">
            <button
              type="button"
              mat-icon-button
              aria-label="Save"
              color="primary"
              (click)="save(site)"
            >
              <mat-icon title="Save">save</mat-icon>
            </button>
          </div>
        </ng-container>
        <ng-template #viewQuantity>
          <app-view-field
            [label]="(site?.name || 'Site') + ' Quantity'"
            [value]="sitesForm.get(site?.id)?.value ?? ''"
            class="quantity-field flex-1 min-w-0"
          />
        </ng-template>
      </div>
    </ng-container>
    <ng-template #emptyState>
      <div class="no-data">No sites available.</div>
    </ng-template>
  </div>
</div>
